import React from 'react';

import { PriceRevealConfig } from '@nykaa/prices-revealed-shared/types';
import LoadableView from './Loadable';


interface PriceRevealProps {
  priceRevealConfig: PriceRevealConfig
}

function View({
  priceRevealConfig,
}: PriceRevealProps) {
  if (priceRevealConfig ) {
    const { data, productEligibilityActive } = priceRevealConfig;

    if (productEligibilityActive && data) {
      return (
        <LoadableView />
      );
    }
  }


  return null;
}

export default View;
